export default __webpack_public_path__ + "static/media/section4-bg2.5e4709cc.png";